export default URL = {
    BACKEND_URL: "/sspy/"
} 